<template>
    <section class="FAQ">
      <SendyModal />
        <div class="portraitWrap"><img v-lazy="imgUrl1"  alt="dwerve"></div>
        <div class="contents" v-html="marked(markdown)"></div>
         <Footer></Footer>
    </section>
</template>

<script>
import VueMarkdown from "vue-markdown";
import Footer from "@/views/Home/Footer.vue";
import marked from "marked";
import SendyModal from "@/views/Home/SendyModal.vue";
import axios from "axios";

export default {
  data() {
    return {
      markdown: "",
      imgUrl1: '/static/assets/images/Dwerve-Promo-Image.jpg',

      // value: require("!raw-loader!./README.md")
    };
  },
  components: {
    Footer,
    VueMarkdown,
    SendyModal
  },
  methods: {
    fetchData() {
      axios.get("/static/faq.md").then(response => {
        this.markdown = response.data;
        // console.log(response.data);
      });
    },
    marked(value) {
      return marked(value);
    }
  },
  mounted() {
    //this.readMarkdown();
    this.fetchData();
  }
};
</script>

<style>
.swal2-container{
      z-index: 9999;
}
.FAQ a {
    color: turquoise;
}
.FAQ h2 {
    font-family: Grandmaster;
    color: #fff;
    font-size: 20px;
    text-shadow: 0 2px 2px rgb(51, 225, 207);
    letter-spacing: 2px;
}
:target {
  display: block;
  position: relative;
  top: -80px; 
  visibility: hidden;
}
.FAQ {
  margin-top: 225px;
  margin-left: auto;
  margin-right: auto;
  z-index: -1;
  color: #fff;
  background: rgb(16, 13, 33);
}
.portraitWrap img {
  width: 100%;
  position: fixed;
      height: 42%;
  opacity: 0.5;
  top: 57px;
  z-index: -1;
  object-fit: cover;
}
.FAQ h1 {
  text-align: center;
  color: #fff;
  padding-bottom: 35px;
  font-size: 4.0625rem;
  font-family: Grandmaster;
  text-shadow: 0 2px 2px rgb(51, 225, 207);
  letter-spacing: 2px;
}
.FAQ h3 {
  font-family: Grandmaster;
  color: #fff;
  font-size: 24px;
}
ul {
  font-size: 18px;
  line-height: 1.5;
}
.contents {
  width: 96%;
  margin-left: auto;
  padding-top: 20px;
  margin-right: auto;
  padding-bottom: 70px;
  max-width: 960px;
}

.FAQ .contents p {
  font-size: 18px;
  line-height: 1.5;
}
</style>


// WEBPACK FOOTER //
// src/views/FAQ.vue